module.exports = __webpack_public_path__ + "img/mail.a2004be8.svg";